// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "getRfqQuotes": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getRfqQuotes( $getRfqQuotesInput: ListRfqQuotesInput, $filters: Json) { getRfqQuotes( getRfqQuotesInput: $getRfqQuotesInput, filters: $filters) { items totalCount error}}",
            "variables": {
              "getRfqQuotesInput": {
                "collaborationspaceId": "{{props.collaborationspaceid}}",
                "skip": "{{data.rfqsSkip}}"
              },
              "sort": "{{data.columnProviders.exampleColumnProvider.sortCriteria}}",
              "filters": "{{data.columnProviders.exampleColumnProvider.columnFilters}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "dataParsers": [{
        "id": "rfqQuoteParser",
        "responseObjs": "data.data.getRfqQuotes.items"
      }],
      "outputData": {
        "filterResults": "data.data.getRfqQuotes.items",
        "totalFound": "data.data.getRfqQuotes.totalCount",
        "error": "data.data.getRfqQuotes.error"
      },
      "actionMessages": {},
      "events": {
        "success": [{
          "condition": "error === 'EMPTY_COLLAB_SPACE'",
          "name": "list-rfq-quotes-as-list.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 400 || errorCode === 400",
          "name": "list-rfq-quotes-as-list.error",
          "eventData": {
            "error": "{{error}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 403 || errorCode === 403",
          "name": "list-rfq-quotes-as-list.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "list-rfq-quotes-as-list.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "error.statusCode >= 500 && error.statusCode <= 599",
          "name": "list-rfq-quotes-as-list.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "list-rfq-quotes-as-list.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "refreshRfqTable": {
      "actionType": "dataProvider",
      "method": "exampleDataProvider"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "data": {
    "pageSize": 3,
    "rfqsSkip": 0
  },
  "onEvent": [{
    "eventId": "list-rfq-quotes-as-list.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-rfq-quotes-as-list.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "dataProviders": {
    "exampleDataProvider": {
      "action": "getRfqQuotes",
      "response": "{{data.filterResults}}",
      "totalFound": "{{data.totalFound}}",
      "contextMenuCommandsAnchor": "aw_splmTableContextMenu",
      "commandsAnchor": "aw_splmTableCommandsAnchor"
    }
  },
  "columnProviders": {
    "exampleColumnProvider": {
      "frozenColumnIndex": 0,
      "columns": [{
        "name": "icon",
        "displayName": "",
        "maxWidth": 30,
        "minWidth": 30,
        "width": 30,
        "enableColumnMenu": false,
        "pinnedLeft": true,
        "enableSorting": false,
        "isFilteringEnabled": false
      }, {
        "name": "name",
        "displayName": "{{i18n.name}}",
        "maxWidth": 150,
        "width": 150,
        "enableColumnMenu": true,
        "pinnedLeft": true,
        "isTableCommand": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }, {
        "name": "description",
        "displayName": "{{i18n.description}}",
        "minWidth": 200,
        "width": 200,
        "enableColumnMenu": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }, {
        "name": "dueDate",
        "displayName": "{{i18n.dueDate}}",
        "minWidth": 160,
        "width": 160,
        "enableColumnMenu": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }, {
        "name": "status",
        "displayName": "{{i18n.status}}",
        "maxWidth": 300,
        "minWidth": 80,
        "width": 100,
        "enableColumnMenu": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }, {
        "name": "owner",
        "displayName": "{{i18n.owner}}",
        "minWidth": 120,
        "width": 150,
        "enableColumnMenu": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }]
    }
  },
  "grids": {
    "ListRFQQuotesTable": {
      "dataProvider": "exampleDataProvider",
      "columnProvider": "exampleColumnProvider",
      "addIconColumn": true,
      "gridOptions": {
        "enableGridMenu": true,
        "enablePinning": true,
        "enableSorting": true,
        "isFilteringEnabled": true,
        "enableColumnHiding": true
      }
    }
  },
  "functions": {
    "filterRows": {
      "functionName": "filterRows",
      "parameters": ["{{data.dataProviders.exampleDataProvider.startIndex}}", "{{data.pageSize}}"]
    }
  },
  "i18n": {
    "quoteRequests": ["RfqMessages"],
    "name": ["RfqMessages"],
    "description": ["RfqMessages"],
    "dueDate": ["RfqMessages"],
    "status": ["RfqMessages"],
    "owner": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "dataParseDefinitions": {
    "rfqQuoteParser": {
      "identifier": "{{response.rfqId}}",
      "typeIconURL": "http://localhost:4012/assets/images/cmdQuoteRequestsList16.svg",
      "type": "RFQ",
      "props": {
        "name": {
          "name": "{{i18n.quoteName}}",
          "displayName": "{{i18n.quoteName}}",
          "value": "{{response.name}}",
          "displayValue": "{{response.name}}",
          "type": "String"
        },
        "description": {
          "name": "{{i18n.description}}",
          "displayName": "{{i18n.description}}",
          "value": "{{response.description}}",
          "displayValue": "{{response.description}}",
          "type": "String"
        },
        "dueDate": {
          "name": "{{i18n.dueDate}}",
          "displayName": "{{i18n.dueDate}}",
          "value": "{{response.dueDate}}",
          "displayValue": "{{response.dueDate}}",
          "type": "String"
        },
        "status": {
          "name": "{{i18n.status}}",
          "displayName": "{{i18n.status}}",
          "value": "{{response.status.name}}",
          "displayValue": "{{response.status.name}}",
          "type": "String"
        },
        "owner": {
          "name": "{{i18n.owner}}",
          "displayName": "{{i18n.owner}}",
          "value": "{{response.owner}}",
          "displayValue": "{{response.owner}}",
          "type": "String"
        }
      }
    }
  },
  "_viewModelId": "ListRfqQuotesAsList",
  "_uniqueViewModelId": "ListRfqQuotesAsList",
  "ctx": {}
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <header class="rfqHeader">{{i18n.quoteRequests}}</header>
    <br>  
    <aw-flex-column class="rfqQuoteFlexColumn">
        <aw-flex-row class="rfqQuoteFlexHeightFill">
            <aw-flex-column class="rfqQuoteFlexWidthFill">
                <aw-splm-table gridid="ListRFQQuotesTable"></aw-splm-table>
            </aw-flex-column>
        </aw-flex-row>
    </aw-flex-column>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("header", {
    className: "rfqHeader"
  }, AwParseService.instance("i18n.quoteRequests")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(AwFlexColumn, {
    className: "rfqQuoteFlexColumn"
  }, /*#__PURE__*/React.createElement(AwFlexRow, {
    className: "rfqQuoteFlexHeightFill"
  }, /*#__PURE__*/React.createElement(AwFlexColumn, {
    className: "rfqQuoteFlexWidthFill"
  }, /*#__PURE__*/React.createElement(AwSplmTable, grids.ListRFQQuotesTable)))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;